import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.search');
import { OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";
import { Subscription } from 'rxjs';
import { AWESOME_LLM_APP_SECTIONS } from '../awesome-llm-apps-catalog';

interface SearchItem {
    id: string;
    title: string;
    category: string;
    summary: string;
    href: string;
    source: string;
    keywords: string[];
}

interface SearchResult {
    item: SearchItem;
    score: number;
    relevance: number;
    matchedTerms: string[];
}

interface CategoryCount {
    name: string;
    count: number;
}

const WIKI_SEARCH_ITEMS: SearchItem[] = AWESOME_LLM_APP_SECTIONS.reduce((items, section) => {
    const sectionItem: SearchItem = {
        id: section.id,
        title: section.title,
        category: '조사 문서 분류',
        summary: section.summary,
        href: `/main/${section.id}`,
        source: 'Wiki Section',
        keywords: [section.title, section.summary, section.description, ...section.related, ...section.entries.map((item) => item.title)],
    };

    const entryItems: SearchItem[] = section.entries.map((item) => ({
        id: item.id,
        title: item.title,
        category: `${section.title} > ${item.category}`,
        summary: item.summary,
        href: item.href,
        source: section.title,
        keywords: [section.title, item.category, ...item.keywords],
    }));

    return items.concat(sectionItem, entryItems);
}, [] as SearchItem[]);

const BASE_SEARCH_ITEMS: SearchItem[] = [
    { id: 'main', title: 'Awesome LLM Wiki', category: '위키 홈', summary: '내부에서 실제 조사한 문서만 검색, 지식 그래프, 재구성 목차로 탐색하는 메인 페이지입니다.', href: '/main', source: 'Main', keywords: ['awesome llm', 'wiki', 'main', '조사', '목차', '지식 그래프'] },
    { id: 'posts', title: '조사 문서 목록', category: '문서 목록', summary: '내부 상세 문서와 조사 카탈로그만 세부 항목 단위로 탐색하는 인덱스입니다.', href: '/posts', source: 'Docs', keywords: ['posts', 'docs', '문서', '목록', '인덱스'] },
    ...WIKI_SEARCH_ITEMS,
];

@Component({
    selector: 'wiz-page-search',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.search/view.scss */
:host {
  display: block;
  width: 100%;
  min-height: 100vh;
  color: #202124;
  background: #ffffff;
  font-family: Inter, "Spoqa Han Sans Neo", "Apple SD Gothic Neo", "Noto Sans KR", sans-serif;
  box-sizing: border-box;
}

.search-page,
.search-page * {
  box-sizing: border-box;
}

.search-header {
  position: sticky;
  top: 0;
  z-index: 10;
  border-bottom: 1px solid #e5e7eb;
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(10px);
}

.search-header__inner {
  width: min(1180px, 100% - 48px);
  min-height: 78px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 148px minmax(0, 720px);
  gap: 28px;
  align-items: center;
}

.search-brand {
  display: flex;
  align-items: center;
  width: 148px;
  color: #111827;
  text-decoration: none;
}

.search-brand__text {
  color: inherit;
  font-size: 18px;
  font-weight: 900;
  line-height: 1;
  letter-spacing: 0;
  white-space: nowrap;
}

.search-form {
  min-width: 0;
  min-height: 48px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 86px;
  border: 1px solid #d7dce2;
  border-radius: 999px;
  background: #ffffff;
  box-shadow: 0 2px 10px rgba(32, 33, 36, 0.08);
  overflow: hidden;
}

.search-form:focus-within {
  border-color: #008c72;
  box-shadow: 0 3px 14px rgba(0, 140, 114, 0.16);
}

.search-form input {
  min-width: 0;
  border: 0;
  padding: 0 18px 0 22px;
  color: #202124;
  background: transparent;
  font: inherit;
  font-size: 16px;
  font-weight: 650;
  outline: none;
}

.search-form input::placeholder {
  color: #80868b;
}

.search-form button {
  border: 0;
  color: #ffffff;
  background: #008c72;
  font: inherit;
  font-size: 14px;
  font-weight: 900;
  cursor: pointer;
}

.search-form button:hover,
.search-form button:focus-visible {
  background: #006f5b;
  outline: none;
}

.search-layout {
  width: min(1180px, 100% - 48px);
  margin: 0 auto;
  display: grid;
  grid-template-columns: minmax(0, 760px) minmax(260px, 320px);
  gap: 60px;
  padding: 34px 0 72px;
  align-items: start;
}

.search-results-column {
  min-width: 0;
}

.search-summary,
.search-empty-state {
  min-width: 0;
  border-bottom: 1px solid #eceff3;
  padding-bottom: 18px;
}

.search-summary__eyebrow {
  margin: 0 0 7px;
  color: #008c72;
  font-size: 12px;
  line-height: 1.35;
  font-weight: 900;
}

.search-summary h1,
.search-empty-state h1 {
  margin: 0;
  color: #202124;
  font-size: 24px;
  line-height: 1.35;
  font-weight: 900;
  overflow-wrap: anywhere;
}

.search-summary p:last-child,
.search-empty-state p {
  margin: 8px 0 0;
  color: #5f6368;
  font-size: 14px;
  line-height: 1.65;
  font-weight: 650;
}

.result-list {
  display: grid;
}

.result-item {
  min-width: 0;
  display: grid;
  gap: 6px;
  border-bottom: 1px solid #eceff3;
  padding: 18px 0;
  color: inherit;
  text-decoration: none;
}

.result-item:hover h2,
.result-item:focus-visible h2 {
  color: #1a0dab;
}

.result-item:focus-visible {
  outline: 2px solid #1a0dab;
  outline-offset: 3px;
}

.result-item__url {
  min-width: 0;
  color: #008c72;
  font-size: 13px;
  line-height: 1.45;
  font-weight: 750;
  overflow-wrap: anywhere;
}

.result-item h2 {
  min-width: 0;
  margin: 0;
  color: #1a0dab;
  font-size: 20px;
  line-height: 1.35;
  font-weight: 850;
  overflow-wrap: anywhere;
}

.result-item p {
  min-width: 0;
  margin: 0;
  color: #4d5156;
  font-size: 14px;
  line-height: 1.65;
  font-weight: 650;
  overflow-wrap: anywhere;
}

.result-item__meta {
  min-width: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  align-items: center;
  color: #70757a;
  font-size: 12px;
  line-height: 1.45;
  font-weight: 800;
}

.result-item__meta b,
.result-item__meta span,
.result-item__meta em {
  font: inherit;
}

.result-item__meta b {
  color: #202124;
}

.result-item__meta em {
  color: #0b57d0;
}

.no-results {
  border-bottom: 1px solid #eceff3;
  padding: 22px 0;
}

.no-results h2 {
  margin: 0;
  color: #202124;
  font-size: 20px;
  line-height: 1.35;
  font-weight: 900;
}

.no-results p {
  margin: 8px 0 0;
  color: #5f6368;
  font-size: 14px;
  line-height: 1.65;
  font-weight: 650;
}

.search-side {
  min-width: 0;
  border-left: 1px solid #eceff3;
  padding-left: 26px;
}

.search-side__section {
  min-width: 0;
  border-bottom: 1px solid #eceff3;
  padding: 0 0 20px;
  margin-bottom: 20px;
}

.search-side__section h2 {
  margin: 0 0 12px;
  color: #202124;
  font-size: 15px;
  line-height: 1.35;
  font-weight: 900;
}

.search-stats {
  margin: 0;
  display: grid;
  gap: 9px;
}

.search-stats div,
.breakdown-list li {
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.search-stats dt,
.search-stats dd {
  margin: 0;
  color: #5f6368;
  font-size: 13px;
  line-height: 1.45;
  font-weight: 750;
}

.search-stats dd,
.breakdown-list strong {
  color: #202124;
  font-weight: 900;
}

.breakdown-list {
  margin: 0;
  padding: 0;
  display: grid;
  gap: 9px;
  list-style: none;
}

.breakdown-list span {
  min-width: 0;
  color: #5f6368;
  font-size: 13px;
  line-height: 1.45;
  font-weight: 750;
  overflow-wrap: anywhere;
}

.suggestion-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.search-empty-state .suggestion-list,
.no-results .suggestion-list {
  margin-top: 14px;
}

.suggestion-list button {
  min-height: 34px;
  border: 1px solid #d7dce2;
  border-radius: 999px;
  padding: 0 12px;
  color: #202124;
  background: #ffffff;
  font: inherit;
  font-size: 13px;
  font-weight: 800;
  cursor: pointer;
}

.suggestion-list button:hover,
.suggestion-list button:focus-visible {
  border-color: #008c72;
  color: #008c72;
  outline: none;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

@media (max-width: 900px) {
  .search-header__inner,
  .search-layout {
    width: min(100% - 32px, 1180px);
  }
  .search-header__inner,
  .search-layout {
    grid-template-columns: 1fr;
    gap: 18px;
  }
  .search-header__inner {
    padding: 16px 0;
  }
  .search-side {
    border-left: 0;
    border-top: 1px solid #eceff3;
    padding: 22px 0 0;
  }
}
@media (max-width: 640px) {
  .search-form {
    grid-template-columns: 1fr;
    border-radius: 18px;
  }
  .search-form input {
    min-height: 48px;
  }
  .search-form button {
    min-height: 42px;
  }
  .search-summary h1,
  .search-empty-state h1 {
    font-size: 22px;
  }
}`],
})
export class PageSearchComponent implements OnInit, OnDestroy {
    public queryInput = '';
    public submittedQuery = '';
    public readonly suggestions = ['벤치마크', 'Transformer', '편집 정책', '위키 분류체계', 'Codex /goal', '보고서'];

    private routeSubscription?: Subscription;

    constructor(@Inject( Service)         public service: Service,@Inject( ActivatedRoute)         private route: ActivatedRoute,@Inject( Router)         private router: Router,    ) { }

    public get allItems(): SearchItem[] {
        return BASE_SEARCH_ITEMS;
    }

    public get benchmarkItems(): SearchItem[] {
        return WIKI_SEARCH_ITEMS.filter((item) => item.category.includes('벤치마크'));
    }

    public get hasQuery(): boolean {
        return !!this.submittedQuery;
    }

    public get results(): SearchResult[] {
        if (!this.hasQuery) {
            return [];
        }

        return this.rankItems(this.submittedQuery)
            .filter((result) => result.score > 0)
            .slice(0, 40);
    }

    public get recommendedItems(): SearchItem[] {
        return BASE_SEARCH_ITEMS.slice(0, 8);
    }

    public get categoryBreakdown(): CategoryCount[] {
        const counts = new Map<string, number>();

        this.results.forEach((result) => {
            counts.set(result.item.source, (counts.get(result.item.source) || 0) + 1);
        });

        return Array.from(counts.entries())
            .map(([name, count]) => ({ name, count }))
            .sort((left, right) => right.count - left.count)
            .slice(0, 5);
    }

    public async ngOnInit() {
        await this.service.init();

        this.routeSubscription = this.route.queryParamMap.subscribe((params) => {
            const query = params.get('q') || '';
            this.queryInput = query;
            this.submittedQuery = query.trim();
        });
    }

    public ngOnDestroy() {
        this.routeSubscription?.unsubscribe();
    }

    public onSearchInput(event: Event) {
        const input = event.target as HTMLInputElement;
        this.queryInput = input.value || '';
    }

    public submitSearch(event: Event) {
        event.preventDefault();
        this.navigateToSearch(this.queryInput);
    }

    public useSuggestion(query: string) {
        this.queryInput = query;
        this.navigateToSearch(query);
    }

    public trackByResult(_: number, result: SearchResult) {
        return result.item.id;
    }

    public trackByItem(_: number, item: SearchItem) {
        return item.id;
    }

    public trackBySuggestion(_: number, suggestion: string) {
        return suggestion;
    }

    public trackByCategory(_: number, category: CategoryCount) {
        return category.name;
    }

    private navigateToSearch(query: string) {
        const nextQuery = query.trim();

        if (!nextQuery) {
            this.router.navigateByUrl('/search');
            return;
        }

        this.router.navigateByUrl(`/search?q=${encodeURIComponent(nextQuery)}`);
    }

    private rankItems(seed: string): SearchResult[] {
        const normalizedSeed = this.normalize(seed);
        const tokens = this.tokenize(normalizedSeed);
        const ranked = this.allItems.map((item) => {
            const title = this.normalize(item.title);
            const category = this.normalize(item.category);
            const summary = this.normalize(item.summary);
            const source = this.normalize(item.source);
            const href = this.normalize(item.href);
            const keywords = item.keywords.map((keyword) => this.normalize(keyword));
            const keywordText = keywords.join(' ');
            const matchedTerms = new Set<string>();
            let score = 0;

            if (normalizedSeed) {
                if (title === normalizedSeed) {
                    score += 90;
                    matchedTerms.add(normalizedSeed);
                } else if (title.includes(normalizedSeed)) {
                    score += 52;
                    matchedTerms.add(normalizedSeed);
                }

                if (keywordText.includes(normalizedSeed)) {
                    score += 40;
                    matchedTerms.add(normalizedSeed);
                }

                if (category.includes(normalizedSeed)) {
                    score += 28;
                    matchedTerms.add(normalizedSeed);
                }

                if (summary.includes(normalizedSeed)) {
                    score += 22;
                    matchedTerms.add(normalizedSeed);
                }
            }

            tokens.forEach((token) => {
                if (title.includes(token)) {
                    score += 18;
                    matchedTerms.add(token);
                }

                if (category.includes(token)) {
                    score += 12;
                    matchedTerms.add(token);
                }

                if (summary.includes(token)) {
                    score += 7;
                    matchedTerms.add(token);
                }

                if (source.includes(token) || href.includes(token)) {
                    score += 5;
                    matchedTerms.add(token);
                }

                const keywordHits = keywords.filter((keyword) => keyword.includes(token)).length;

                if (keywordHits) {
                    score += keywordHits * 10;
                    matchedTerms.add(token);
                }
            });

            return {
                item,
                score,
                relevance: 0,
                matchedTerms: Array.from(matchedTerms).slice(0, 6),
            };
        }).sort((left, right) => {
            if (right.score !== left.score) {
                return right.score - left.score;
            }

            return left.item.title.localeCompare(right.item.title);
        });

        const topScore = ranked.find((result) => result.score > 0)?.score || 1;

        return ranked.map((result) => ({
            ...result,
            relevance: result.score > 0 ? Math.max(1, Math.round((result.score / topScore) * 100)) : 0,
        }));
    }

    private tokenize(value: string): string[] {
        return value
            .split(/[^0-9a-zA-Z가-힣]+/)
            .map((token) => token.trim())
            .filter((token) => token.length > 1);
    }

    private normalize(value: string): string {
        return value.toLowerCase().trim();
    }
}

export default PageSearchComponent;